<template>
  <div>
    <div class="swiper-container cards-home">
      <div class="swiper-wrapper" role="list">
        <div role="listitem" class="swiper-slide" v-for="(d, index) in avisos" :key="index">
          <div class="border bg-white pr-2 card-home d-flex align-items-center" @click="goTo(d)" :class="{'pointer': d.link}">
            <icon :name="d.icon" size="16" class="mx-2 text-primary" :class="d.animated ? 'animated fadeIn infinite' : ''" v-if="d.icon"/>
            <i class="fa fa-blink mx-2" :class="d.ficon + ' ' + d.customClass" v-else-if="d.ficon"></i>
            <div>
              <h4 class="font-weight-bold m-0" style="font-size: 12px" v-html="d.titulo"></h4>
              <div style="font-size: 10px">{{d.descricao}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css'
  import CardInfo from "../../../components/CardInfo";
  import Cupom from "../../../components/Cupom";
  import Icon from "../../../components/Icon";

  export default {
    name: "CardsHome",
    components: {Icon, Cupom, CardInfo},
    props: ['avisos'],
    data() {
      return {
        destaques: [],
      }
    },

    methods: {
      goTo(d) {
        if (d.link) {
          this.$router.push(d.link)
        }
      }
    },
    mounted() {
      let swiper = new Swiper('.cards-home', {
        slidesPerView: 'auto',
        freeMode: true,
        // autoplay: {
        //   delay: 3000,
        // }
      });
    }
  }
</script>

<style scoped>
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: auto;
    padding-right: 6px;
  }

  .card-home {
    width: 100%;
    height: 45px;
    border-radius: 12px;
  }

  @keyframes fa-blink {
    0% { opacity: 0; }
    25% { opacity: 0.75; }
    100% { opacity: 1; }
  }

  .fa-blink {
    -webkit-animation: fa-blink 3s linear infinite;
    -moz-animation: fa-blink 3s linear infinite;
    -ms-animation: fa-blink 3s linear infinite;
    -o-animation: fa-blink 3s linear infinite;
    animation: fa-blink 3s linear infinite;
  }
</style>
